// src/__internal__/utils/isServer.ts
function isServer() {
  return typeof window === "undefined";
}
export {
  isServer
};
